import { registerFunctionalComponent } from 'js/lib/components/component'

const COLLAPSED_MASK = 'linear-gradient(to bottom, black 50%, transparent 100%)'

registerFunctionalComponent('.js-c-ui-expandable', 'UiExpandableComponent', initUiExpandable)

function initUiExpandable(component) {
  const container = component.element.querySelector('.js-c-ui-expandable__container')
  const toggle = component.element.querySelector('.js-c-ui-expandable__toggle')

  // Exit early if required elements don't exist
  if (!container || !toggle) {
    return
  }

  // Store the initial/collapsed height from the inline style
  const collapsedHeight = container.style.height
  let isExpanded = false

  // Apply mask only if content actually overflows the collapsed height
  if (container.scrollHeight > container.offsetHeight) {
    container.style.maskImage = COLLAPSED_MASK
  }

  component.useHandler(() => {
    const handleToggle = () => {
      isExpanded = !isExpanded

      if (isExpanded) {
        // Get the full scroll height
        const fullHeight = container.scrollHeight
        container.style.height = `${fullHeight}px`
        container.style.maskImage = 'none'

        // Update button text
        const buttonText = toggle.querySelector('span')
        if (buttonText) buttonText.textContent = 'Show less'

        // Update aria-expanded
        toggle.setAttribute('aria-expanded', 'true')
      } else {
        // Collapse back to original height
        container.style.height = collapsedHeight
        container.style.maskImage = COLLAPSED_MASK

        // Update button text - get original text from data attribute if available
        const buttonText = toggle.querySelector('span')
        if (buttonText) buttonText.textContent = toggle.dataset.originalText || 'View details'

        // Update aria-expanded
        toggle.setAttribute('aria-expanded', 'false')
      }
    }

    // Store original button text
    const buttonText = toggle.querySelector('span')
    if (buttonText) {
      toggle.dataset.originalText = buttonText.textContent
    }

    toggle.addEventListener('click', handleToggle)

    return () => toggle.removeEventListener('click', handleToggle)
  })
}
